module.exports = "pegasus/assets/blocks/header-6-theme2.png";